export const OFFICE_ROLES = ['admin', 'secretary', 'sekretariat', 'verwaltung', 'management'];

/** Rollen-Flags fürs Startfenster (Vorgangs-Karten vs. Admin-Widgets). */
export function getStartfensterAccess(roleNames, { isSuperAdmin = false, isLegacyFallback = false } = {}) {
  const roles = new Set(roleNames);
  const hasOfficeRole = OFFICE_ROLES.some((role) => roles.has(role));
  const isVerwaltungRole = roles.has('verwaltung') || roles.has('management');
  const isTeacher = (roles.has('teacher') || roles.has('lehrer'))
    && !isSuperAdmin
    && !OFFICE_ROLES.some((role) => roles.has(role));
  const isAdminish = !isTeacher && (isSuperAdmin || isLegacyFallback || hasOfficeRole);
  return {
    isTeacher,
    isAdminish,
    isVerwaltungRole,
    showDataQuality: !isVerwaltungRole,
    showAdminDashboardWidgets: isAdminish && !isVerwaltungRole,
    /** Funnel-Widget „Online-Anmeldungen“ (Letzte 30 Tage) — Inbox bleibt über die Vorgangs-Karte. */
    showRegistrationsTracker: false,
  };
}
